import { render, staticRenderFns } from "./product.vue?vue&type=template&id=4add76f0&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&id=4add76f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add76f0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BundleProduct: require('/opt/build/repo/storefront/components/legacy/global/bundle-product.vue').default,Slider: require('/opt/build/repo/storefront/components/legacy/global/slider.vue').default,ShippingTimer: require('/opt/build/repo/storefront/components/legacy/global/shipping-timer.vue').default,Crosssell: require('/opt/build/repo/storefront/components/legacy/global/crosssell.vue').default})
